import { useLocalStorage } from "@uidotdev/usehooks";

export interface PropertyResult {
  property_id: number;
  name: string;
  path: string;
  city: string;
  country_code: string;
  latitude?: number;
  longitude?: number;
  photo_path?: string;
}

export interface RecentLookup {
  property_id: number;
  name: string;
  url: string;
  lastChecked: string;
  path: string;
  city: string;
  country_code: string;
}

export function usePropertyLookup(onSelectProperty: (selectedPropertyId: number) => void) {
  const [recentLookups, setRecentLookups] = useLocalStorage<RecentLookup[]>(
    'property-lookup-history',
    []
  );

  const handleSelectProperty = (property: PropertyResult) => {
    const newLookup: RecentLookup = {
      property_id: property.property_id,
      name: property.name,
      url: `https://www.booking.com/${property.path}`,
      lastChecked: 'Just now',
      path: property.path,
      city: property.city,
      country_code: property.country_code
    };

    setRecentLookups(prev => {
      // Remove if already exists
      const filtered = prev.filter(item => item.property_id !== newLookup.property_id);
      // Add to beginning of array
      return [newLookup, ...filtered].slice(0, 10); // Keep last 10
    });

    onSelectProperty(property.property_id);
  };

  const handleSelectRecentLookup = (lookup: RecentLookup) => {
    onSelectProperty(lookup.property_id);
  };

  return {
    recentLookups,
    handleSelectProperty,
    handleSelectRecentLookup,
  };
}